import Duck from "redux-ducks-ts"

export const quoter = new Duck("quoter", "cargo")
